import React from 'react';

const InformationSystems = () => {
  return (
    <div>
      InformationSystems
      InformationSystems
    </div>
  );
}

export default InformationSystems;
